<template>
    <div class="modal-title">Редактирование СНИЛС</div>
    <form class="modal-form">
        <input-text
            label       = "СНИЛС"
            required    = "*"
            :errorText  = "updateError"
            placeholder = "СНИЛС"
            maskVal     = "snils"
            name        = "snils"
            ref         = "snilsInput"
            disabled    = "inputDisabled"
            :defValue   = "snils"
            @onComplete = "getValue"
        />
        <div class="modal-button flex">
            <orange-button
                text            = "Сохранить"
                @click.prevent  = "userUpdate"
                ref             = "submitButton"
            />
            <button class="button reset" @click.prevent="$emit('showModal')">Отмена</button>
        </div>
    </form>
</template>

<script>
import axios from "axios"

export default {
    name: 'modal-edit-snils',
    emits: ['showModal'],
    data() {
        return {
            snils: this.$store.state.dataUser.snils,
            apiUrl: this.$store.state.apiUrl,
            token: this.$store.state.token,
            updateError: false
        }
    },
    methods: {
        async userUpdate() {
            try {
                let data = {
                    user: {
                        snils: this.snils
                    }
                }

                const response = await axios.patch(
                    this.apiUrl + '/api/user',
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        }
                    }
                )
                this.$emit('showModal')
                this.$store.commit('getUserInfo')
            } catch (e) {
                console.log(e.response ? { status: e.response.status, data: e.response.data } : e.message)
                if (e.response.data.message)
                    this.updateError = e.response.data.message

                console.log(e.response.data)
            }
        },
        getValue(e) {
            this.snils = e.value
        },
        setInputDisabled(status) {
            if (this.$refs.submitButton)
                this.$refs.submitButton.setDisabled(status)
        },
    }
}
</script>